import { Component, OnInit, Input } from "@angular/core";

@Component({
  selector: "app-data-grid-empty-table",
  templateUrl: "./empty-table.component.html",
  styleUrls: ["./empty-table.component.scss"]
})
export class DataGridEmptyTableComponent implements OnInit {

  @Input()
  public name: string;

  @Input()
  public link: string;

  constructor() { }

  ngOnInit(): void { }

}
